import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
 
@Injectable()
export class MetadataService {

   constructor(private http: HttpClient) { }
   get(url):any{
	 return this.http.get(`/fetch?url=${url}`).toPromise();
   }
}


